var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "liff-staff-list"
  }, [_c('div', {
    staticClass: "liff-staff-list__content",
    class: {
      'need-bottom': !!_vm.branchId
    }
  }, [_vm.reservationBranchProvider ? _c('ShopSelection', {
    ref: "shopSelection",
    attrs: {
      "branch-provider": _vm.reservationBranchProvider,
      "show-branch-code": _vm.branchCodeIsShown,
      "placeholder": _vm.displayPlaceholder,
      "disabled": !_vm.configurationIsValid
    },
    on: {
      "setBranchModel": _vm.setSelectedBranch
    },
    model: {
      value: _vm.branchId,
      callback: function callback($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  }) : _vm._e(), Object.keys(_vm.selectedBranch).length !== 0 && _vm.branchId ? _c('div', {
    staticClass: "py-3"
  }, [_c('div', {
    staticClass: "branch__title"
  }, [_vm._v(_vm._s(_vm.selectedBranch.name))]), _vm.displayBranchDetail ? [_c('div', {
    staticClass: "position-relative"
  }, [_c('span', {
    staticClass: "branch__section__toggle"
  }, [_c('i', {
    staticClass: "mdi mdi-chevron-down mdi-24px",
    class: {
      'mdi-rotate-180': _vm.isBranchDetailOpen
    }
  })]), _vm._l(_vm.isBranchDetailOpen ? _vm.branchDetailMapping : _vm.branchDetailMapping.slice(0, 1), function (group, idx) {
    return _c('div', {
      key: idx,
      staticClass: "branch__section mt-3"
    }, [_c('div', {
      staticClass: "branch__section__wrapper"
    }, _vm._l(_vm.isBranchDetailOpen ? group : group.slice(0, group[0].col_span ? 1 : 2), function (field, idx2) {
      return _c('div', {
        key: idx2,
        staticClass: "branch__section__item d-flex flex-row align-items-start",
        class: field.col_span,
        on: {
          "click": function click($event) {
            idx == 0 && (group[0].col_span ? [0] : [0, 1]).includes(idx2) ? _vm.isBranchDetailOpen = !_vm.isBranchDetailOpen : null;
          }
        }
      }, [_c('div', {
        staticClass: "d-flex flex-column flex-fill"
      }, [_c('div', {
        staticClass: "branch__section__title"
      }, [_vm._v(_vm._s(field.title))]), _c('div', {
        staticClass: "branch__section__value"
      }, [_vm._v(" " + _vm._s(_vm.selectedBranch[field.matched_key]) + " ")])])]);
    }), 0)]);
  })], 2)] : _vm._e(), _vm.displayBranchImages ? _c('div', {
    staticClass: "branch__images mt-3"
  }, [_c('b-carousel', {
    staticClass: "branch__images__carousel mb-4",
    attrs: {
      "interval": 0,
      "indicators": _vm.selectedBranch.images.length > 1,
      "no-wrap": true
    },
    model: {
      value: _vm.slide,
      callback: function callback($$v) {
        _vm.slide = $$v;
      },
      expression: "slide"
    }
  }, _vm._l(_vm.selectedBranch.images, function (img) {
    return _c('b-carousel-slide', {
      key: img.id,
      scopedSlots: _vm._u([{
        key: "img",
        fn: function fn() {
          return [_c('img', {
            staticClass: "d-block img-fluid w-100",
            attrs: {
              "src": img.url
            }
          })];
        },
        proxy: true
      }], null, true)
    });
  }), 1), _vm.selectedBranch.images.length > 1 ? _c('button', {
    staticClass: "carousel-control-prev",
    attrs: {
      "disabled": _vm.slide === 0,
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function click($event) {
        _vm.slide--;
      }
    }
  }, [_c('span', {
    staticClass: "carousel-control-prev-icon"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next slide")])]) : _vm._e(), _vm.selectedBranch.images.length > 1 ? _c('button', {
    staticClass: "carousel-control-next",
    attrs: {
      "disabled": _vm.slide === _vm.selectedBranch.images.length - 1,
      "href": "#",
      "role": "button"
    },
    on: {
      "click": function click($event) {
        _vm.slide++;
      }
    }
  }, [_c('span', {
    staticClass: "carousel-control-next-icon"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next slide")])]) : _vm._e()], 1) : _vm._e()], 2) : _vm._e()], 1), _c('div', {
    staticClass: "wizard-mode-layout__footer-navigation"
  }, [_c('div', {
    staticClass: "wizard-mode-layout__footer-button-wrapper"
  }, [_vm.hasPreviousStep() ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline s-btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleNegativeButtonClicked
    }
  }, [_vm._v(" 上一步 ")]) : _vm._e(), _c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.branchId || !_vm.configurationIsValid
    },
    on: {
      "click": _vm.handlePositiveButtonClicked
    }
  }, [_vm._v(" " + _vm._s(_vm.textForProceedButton()) + " ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }